import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { AbilitiesQuery as AbilitiesQueryType, AbilitiesQueryVariables } from "./__generated__/AbilitiesQuery";

const AbilitiesQuery = loader("./AbilitiesQuery.gql");

type AbilitiesQueryProviderType = (props: {
  children: (data: AbilitiesQueryType) => ReactNode;
  variables: AbilitiesQueryVariables;
}) => ReactElement;

export const AbilitiesQueryProvider: AbilitiesQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<AbilitiesQueryType, AbilitiesQueryVariables>(AbilitiesQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
